import React from "react"
import styled from "styled-components"

const StyledDiv = styled.div`
  width: 100%;
  display: block;
`

const Title = styled.h2`
  margin: 0;
  padding: 0.5rem 2rem 0 0;
  display: block;
  font-size: 1rem;
`

const Description = styled.div`
  padding: 0.5rem 2rem 0.5rem 0;
  display: block;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.45);
`

type RecruitDetailProps = {
  title: string
  description: string
} & React.ComponentProps<typeof StyledDiv>

export const RecruitDetail = ({
  title,
  description,
  ...props
}: RecruitDetailProps) => {
  const desc =
    description.length > 80 ? description.slice(0, 80) + "..." : description
  return (
    <StyledDiv {...props}>
      <Title>{title}</Title>
      <Description>{desc}</Description>
    </StyledDiv>
  )
}
